var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKebabHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.74121C0 1.63652 0.895782 0.741211 2 0.741211C3.10422 0.741211 4 1.63652 4 2.74121C4 3.8459 3.10505 4.74121 2 4.74121C0.894955 4.74121 0 3.8459 0 2.74121V2.74121Z",
    fill: "#799D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.74121C0 8.63652 0.894955 7.74121 2 7.74121C3.10505 7.74121 4 8.63652 4 9.74121C4 10.8459 3.10505 11.7412 2 11.7412C0.894955 11.7412 0 10.8459 0 9.74121Z",
    fill: "#799D33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.7412C0 15.6365 0.894954 14.7412 2 14.7412C3.10505 14.7412 4 15.6365 4 16.7412C4 17.8459 3.10505 18.7412 2 18.7412C0.894954 18.7412 0 17.8459 0 16.7412Z",
    fill: "#799D33"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKebabHover);
export default __webpack_public_path__ + "static/media/kebab-hover.338ba4118fc12aba45ec1724008be5c9.svg";
export { ForwardRef as ReactComponent };